import { Component, AfterViewInit } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-autor',
  templateUrl: './autor.component.html',
  styleUrls: ['./autor.component.css']
})
export class AutorComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.section-autor .anim').forEach(el => observer.observe(el));
  }
}
